// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2TWDi","column":"style_column__ZCJfy","row":"style_row__3jCe3"};